module.exports = __webpack_public_path__ + "statics/img/dizzy-880d2dc9.png";


//////////////////
// WEBPACK FOOTER
// ./web/components/error/dizzy.png
// module id = 187
// module chunks = 0 3 7 8 9 10 12 13 16 17 23 24 25 30 35 36 37 38 39 40 41 44 49 52 53 54 55 74 77 92 93 94 95 97 100 101 103 104 105 106 109 111 114 118 119 120 121 125 162 164 165 166 168 169 170 171